import { useRef } from "react";

import Banner from "./Banner";
import JobInformation from "./JobInformation";
import FormSection from "./FormSection";

const JobDetails = () => {
  const applyFormRef = useRef(null);

  return (
    <>
      <div className="bg-white text-gray-800">
        {/* Header */}

        <Banner
          config={{
            applyFormRef,
            title: "PHP Developer",
          }}
        />

        {/* Content */}
        <div className="bg-white px-6 md:px-16 py-12">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 items-start">
            {/* LEFT SIDE: JOB DESCRIPTION */}

            <div className="lg:col-span-2 space-y-12">
              {/* Job Summary Section */}
              <div>
                <h2 className="text-[32px] font-semibold text-[#212129] mb-6">
                  Job Summary
                </h2>

                <p className="text-[#212129] text-[18px] leading-8 mb-6">
                  We are on the lookout for a motivated and enthusiastic PHP
                  Developer to join us as a fresher. The ideal candidate should
                  have a strong foundation in PHP programming, a willingness to
                  learn, and the drive to contribute meaningfully to development
                  projects. This is a great opportunity to work with experienced
                  developers and get hands-on experience in building scalable
                  web applications.
                </p>

                {/* Key Responsibilities */}
                <h3 className="text-[20px] font-semibold text-green-600 mb-1">
                  Key Responsibilities
                </h3>
                <div className="w-[100px] h-[2px] bg-green-600 mb-4" />

                <ul className="list-disc ml-6 space-y-2 text-[#212129] text-[18px] leading-7">
                  <li>
                    Assist in the design, development, testing, and deployment
                    of web applications using PHP.
                  </li>
                  <li>
                    Work primarily on back-end components and integrate
                    front-end elements.
                  </li>
                  <li>
                    Collaborate with UI/UX teams, designers, and other
                    developers to deliver efficient solutions.
                  </li>
                  <li>Write clean, maintainable, and well-documented code.</li>
                  <li>Integrate third-party services and RESTful APIs.</li>
                </ul>
              </div>

              {/* Qualifications */}
              <div>
                <h3 className="text-[20px] font-semibold text-green-600 mb-1">
                  Qualifications
                </h3>
                <div className="w-[100px] h-[2px] bg-green-600 mb-4" />

                <ul className="list-disc ml-6 space-y-2 text-[#212129] text-[18px] leading-7">
                  <li>
                    Bachelor’s degree in Computer Science, IT, Engineering, or a
                    related field.
                  </li>
                  <li>(Eligible: B.Sc (CS/IT), B.E/B.Tech, BCA, MCA)</li>
                  <li>
                    Basic understanding of web development concepts and PHP
                    environment.
                  </li>
                  <li>
                    Internship or academic project experience in PHP or web
                    development is a plus.
                  </li>
                </ul>
              </div>

              {/* Skills and Competencies */}
              <div>
                <h3 className="text-[20px] font-semibold text-green-600 mb-1">
                  Skills & Competencies
                </h3>
                <div className="w-[100px] h-[2px] bg-green-600 mb-4" />

                <ul className="list-disc ml-6 space-y-2 text-[#212129] text-[18px] leading-7">
                  <li>Proficiency in PHP programming language.</li>
                  <li>
                    Familiarity with PHP frameworks such as Lumen, Laravel, or
                    CodeIgniter (preferred).
                  </li>
                  <li>
                    Working knowledge of jQuery, AJAX, and React or any other
                    frontend framework (preferred).
                  </li>
                  <li>
                    Basic understanding of RESTful APIs and integration
                    techniques.
                  </li>
                  <li>Strong analytical and problem-solving skills.</li>
                  <li>Excellent communication and teamwork abilities.</li>
                </ul>
              </div>

              {/* Why Join Us */}
              <div>
                <h3 className="text-[20px] font-semibold text-green-600 mb-1">
                  Why Join Us?
                </h3>
                <div className="w-[100px] h-[2px] bg-green-600 mb-4" />

                <ul className="list-disc ml-6 space-y-2 text-[#212129] text-[18px] leading-7">
                  <li>Work on live projects and real-world applications.</li>
                  <li>
                    Learn and grow under the guidance of experienced
                    professionals.
                  </li>
                  <li>Friendly and collaborative work culture.</li>
                  <li>
                    Opportunity to build a strong foundation for a successful
                    career in web development.
                  </li>
                </ul>
              </div>
            </div>

            <JobInformation />
          </div>
        </div>

        {/* Apply Form */}
      </div>

      <FormSection applyFormRef={applyFormRef} />
    </>
  );
};

export default JobDetails;
